module.exports = __webpack_public_path__ + "media/images/information/bug-3c1e7f317d18183d5bde9b8588be9757.svg";